import React, { useEffect, useState, useMemo, useRef } from "react";
import { Badge, Group, Paper, Stack, Text, Title, Loader } from "@mantine/core";
import moment from "moment";
import { PageList, ENUM_FORM_DISPLAY } from "../../components/pageList";
import { useServerApi } from "../../hooks/userServerApi";

const apiEntity = "notificationLog";

const formSchema = {
  title: "Notification Log",
  apiEntity,
  display: { mode: ENUM_FORM_DISPLAY.MODAL, size: "sm" },
  initialValues: {},
  layout: { fields: [] },
};

const NotificationLogs = () => {
  const [api] = useServerApi();
  const apiRef = useRef(api);
  apiRef.current = api;
  const [stats, setStats] = useState(null);
  const [loadingStats, setLoadingStats] = useState(true);

  useEffect(() => {
    let cancelled = false;
    apiRef.current.Notification.getLogStats().then((res) => {
      if (cancelled) return;
      if (res?.data) setStats(res.data);
      setLoadingStats(false);
    });
    return () => {
      cancelled = true;
    };
  }, []);

  const tableSchema = useMemo(
    () => ({
      columns: [
        {
          field: "sentAt",
          headerName: "Sent At",
          width: 160,
          cellRender: (col, data) =>
            data?.sentAt ? moment(data.sentAt).format("YYYY-MM-DD HH:mm") : "",
        },
        { field: "ruleName", headerName: "Rule", width: 180 },
        { field: "targetEntity", headerName: "Entity", width: 100 },
        { field: "field", headerName: "Field", width: 120 },
        { field: "recipientEmail", headerName: "Recipient", width: 200 },
        { field: "subject", headerName: "Subject", width: 240 },
        {
          field: "status",
          headerName: "Status",
          width: 100,
          cellRender: (col, data) => (
            <Badge
              size="sm"
              color={
                data?.status === "SENT" ? "green" : data?.status === "FAILED" ? "red" : "gray"
              }
            >
              {data?.status}
            </Badge>
          ),
        },
        {
          field: "error",
          headerName: "Error",
          width: 180,
          cellRender: (col, data) => data?.error ?? "",
        },
      ],
    }),
    []
  );

  return (
    <Stack spacing="md">
      <Title order={3}>Notification Logs</Title>
      {loadingStats ? (
        <Loader size="sm" />
      ) : stats ? (
        <Group>
          <Paper p="sm" withBorder>
            <Text size="xs" color="dimmed">
              Total
            </Text>
            <Text weight={700}>{stats.total}</Text>
          </Paper>
          <Paper p="sm" withBorder>
            <Text size="xs" color="dimmed">
              Sent
            </Text>
            <Text weight={700}>{stats.byStatus?.SENT ?? 0}</Text>
          </Paper>
          <Paper p="sm" withBorder>
            <Text size="xs" color="dimmed">
              Failed
            </Text>
            <Text weight={700}>{stats.byStatus?.FAILED ?? 0}</Text>
          </Paper>
        </Group>
      ) : null}
      <PageList
        apiEntity={apiEntity}
        title="Notification Logs"
        formSchema={formSchema}
        showAddButton={false}
        tableSchema={tableSchema}
        initSort={{ by: "sentAt", order: "desc" }}
      />
    </Stack>
  );
};

export default NotificationLogs;
